var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEcosystem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.125V6.875",
    stroke: "white",
    strokeWidth: 1.43617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.875L6.25 10",
    stroke: "white",
    strokeWidth: 1.43617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L13.75 8.125",
    stroke: "white",
    strokeWidth: 1.43617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3517 14.1561C10.9251 14.5467 11.5735 14.8136 12.2557 14.94C12.9379 15.0664 13.6389 15.0494 14.3141 14.8901C14.9894 14.7308 15.6241 14.4328 16.1779 14.0149C16.7318 13.597 17.1925 13.0685 17.531 12.4628C17.8695 11.8572 18.0782 11.1878 18.1439 10.4971C18.2096 9.80642 18.1308 9.10964 17.9126 8.45106C17.6944 7.79248 17.3415 7.18652 16.8764 6.67172C16.4113 6.15692 15.8442 5.74454 15.211 5.46083C15.072 5.39094 14.9616 5.27496 14.8985 5.1327C14.4935 4.16783 13.8126 3.34406 12.9411 2.76475C12.0697 2.18545 11.0465 1.8764 10.0001 1.8764C8.95367 1.8764 7.93054 2.18545 7.05909 2.76475C6.18764 3.34406 5.50668 4.16783 5.10166 5.1327C5.03863 5.27496 4.92818 5.39094 4.78916 5.46083C4.15604 5.74454 3.58889 6.15692 3.12379 6.67172C2.65868 7.18652 2.30581 7.79248 2.0876 8.45106C1.86939 9.10964 1.79063 9.80642 1.85633 10.4971C1.92202 11.1878 2.13074 11.8572 2.46919 12.4628C2.80765 13.0685 3.26844 13.597 3.82226 14.0149C4.37608 14.4328 5.0108 14.7308 5.68606 14.8901C6.36132 15.0494 7.06234 15.0664 7.74452 14.94C8.4267 14.8136 9.07512 14.5467 9.64854 14.1561C9.75297 14.0876 9.87517 14.0511 10.0001 14.0511C10.125 14.0511 10.2472 14.0876 10.3517 14.1561Z",
    stroke: "white",
    strokeWidth: 1.43617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEcosystem);
export default __webpack_public_path__ + "static/media/icon-ecosystem.7bf8856624159bc0218f729d54bea8cb.svg";
export { ForwardRef as ReactComponent };